"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setInjection(options, propertyName, value) {
    var opt = options;
    if (!opt.__injections__) {
        opt.__injections__ = new Map();
    }
    opt.__injections__.set(propertyName, value);
}
exports.setInjection = setInjection;
function getInjections(options) {
    var opt = options;
    return opt.__injections__;
}
exports.getInjections = getInjections;
function getInjection(options, propertyName) {
    var opt = options;
    if (!opt.__injections__) {
        return undefined;
    }
    return opt.__injections__.get(propertyName);
}
exports.getInjection = getInjection;
//# sourceMappingURL=utils.js.map